import React from 'react';
import { CellProps } from 'react-table';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import classNames from 'classnames';
import styles from '../assets/vendor-actions.module.scss';
import { IVendor } from 'src/types/vendor';

const VendorActionsColumn: React.FunctionComponent<CellProps<IVendor>> = ({
    cell: {
        row: { original },
    },
}: CellProps<IVendor>) => {
    return (
        <div className={classNames(styles.actions)}>
            <Link to={Router.generate(routes.VENDOR_DETAIL, { id: original.id })}>{original.name}</Link>
        </div>
    );
};

export default VendorActionsColumn;
